import { useCallback } from "react";
import { useUI } from "../../../Context/UIContext";

const formatFeedbackMessage = ({ title, message, detail }) =>
  [title, message, detail].filter(Boolean).join("\n");

const isErrorFeedback = (title = "") => {
  const normalized = title.toLowerCase();
  return (
    normalized.includes("errore")
    || normalized.includes("non riusc")
    || normalized.includes("non disponibile")
    || normalized.includes("mancata")
  );
};

export function useNewsletterPublishFeedback() {
  const { showSuccess, showError } = useUI();

  return useCallback((payload) => {
    if (!payload) {
      return;
    }
    const text = formatFeedbackMessage(payload);
    if (isErrorFeedback(payload.title)) {
      showError(text);
      return;
    }
    showSuccess(text);
  }, [showError, showSuccess]);
}
